import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React from "react";

export default function MortgageTypeInput({
  interestOnly,
  interestRate,
  desiredMonthlyPayment,
  onChange,
  mode,
}: {
  interestOnly: boolean | undefined;
  interestRate: number | undefined;
  desiredMonthlyPayment: number | undefined;
  onChange: (changes: {
    interestOnly: boolean;
    desiredMonthlyPayment?: number;
    interestRate?: number;
  }) => void;
  mode?: "monthlyPayment" | "interestRate" | "default";
}) {
  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        Mortgage Type
      </Typography>
      <ToggleButtonGroup
        exclusive
        value={interestOnly ? "interestOnly" : "repayment"}
        onChange={(e, val) => {
          if (!val) return;
          if (val === "interestOnly" && interestRate && desiredMonthlyPayment) {
            // Only one of Interest Rate or Monthly Payment allowed for Interest Only
            // Clear the one that is NOT the comparison variable for this form
            if (mode === "monthlyPayment") {
              onChange({ interestOnly: true, interestRate: undefined });
            } else {
              onChange({
                interestOnly: true,
                desiredMonthlyPayment: undefined,
              });
            }
          } else {
            onChange({ interestOnly: val === "interestOnly" });
          }
        }}
        size="small"
      >
        <ToggleButton value="repayment">Repayment</ToggleButton>
        <ToggleButton value="interestOnly">Interest Only</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
